(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    


document.querySelectorAll('.menu-lnk.has-item > a').forEach(function(link) {
    link.addEventListener('click', function(e) {
        e.preventDefault();
    });
});
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.classList.add('hide');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.classList.toggle('hide');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);


/* ====== Predictive search (desktop + mobile) ====== */
(function () {
  var SUGGEST_URL = '/search/suggest.json';
  var DEBOUNCE_MS = 250;
  var LIMIT = 6;
  var MIN_CHARS = 2;

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#039;');
  }

  function formatPrice(p) {
    if (p === null || p === undefined || p === '') return '';
    var num = parseFloat(p);
    if (isNaN(num)) return '';
    return num.toFixed(2);
  }

  function fetchSuggestions(q) {
    var url = SUGGEST_URL +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product' +
      '&resources[limit]=' + LIMIT +
      '&resources[options][unavailable_products]=last';
    return fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.resources && data.resources.results && data.resources.results.products) {
          return data.resources.results.products;
        }
        return [];
      })
      .catch(function () { return []; });
  }

  function render(container, products, q) {
    if (!products.length) {
      container.innerHTML = '<div class="header-search-suggestions__empty">No products found</div>';
      container.classList.add('is-open');
      return;
    }
    var html = products.map(function (p) {
      var img = p.featured_image && p.featured_image.url
        ? '<img class="header-search-suggestion__img" src="' + escapeHtml(p.featured_image.url) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">'
        : '<div class="header-search-suggestion__img"></div>';
      var price = formatPrice(p.price);
      var priceHtml = price ? '<p class="header-search-suggestion__price">' + escapeHtml(price) + '</p>' : '';
      return '<a class="header-search-suggestion" href="' + escapeHtml(p.url) + '">'
        + img
        + '<div class="header-search-suggestion__info">'
        + '<p class="header-search-suggestion__title">' + escapeHtml(p.title) + '</p>'
        + priceHtml
        + '</div></a>';
    }).join('');
    html += '<a class="header-search-suggestions__viewall" href="/search?q=' + encodeURIComponent(q) + '&type=product">View all results for &ldquo;' + escapeHtml(q) + '&rdquo;</a>';
    container.innerHTML = html;
    container.classList.add('is-open');
  }

  function bindSearch(form, suggBox) {
    if (!form || !suggBox) return;
    var input = form.querySelector('.header-search-input');
    if (!input) return;

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < MIN_CHARS) {
        suggBox.classList.remove('is-open');
        suggBox.innerHTML = '';
        return;
      }
      suggBox.innerHTML = '<div class="header-search-suggestions__loading">Searching&hellip;</div>';
      suggBox.classList.add('is-open');
      fetchSuggestions(q).then(function (products) {
        if (input.value.trim() === q) render(suggBox, products, q);
      });
    }, DEBOUNCE_MS);

    input.addEventListener('input', run);
    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && suggBox.innerHTML) {
        suggBox.classList.add('is-open');
      }
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') suggBox.classList.remove('is-open');
    });

    document.addEventListener('click', function (e) {
      if (!form.contains(e.target) && !suggBox.contains(e.target)) {
        suggBox.classList.remove('is-open');
      }
    });
  }

  function init() {
    /* Desktop */
    var dForm = document.querySelector('.header-search-item .header-search-form');
    var dSugg = document.querySelector('.header-search-item .header-search-suggestions');
    bindSearch(dForm, dSugg);

    /* Mobile */
    var overlay = document.getElementById('MobileSearchOverlay');
    var mForm = overlay ? overlay.querySelector('.header-search-form') : null;
    var mSugg = overlay ? overlay.querySelector('.header-search-suggestions') : null;
    bindSearch(mForm, mSugg);

    /* Mobile toggle */
    var toggle = document.querySelector('.mobile-search-toggle');
    var closeBtn = overlay ? overlay.querySelector('.mobile-search-close') : null;

    function openOverlay() {
      if (!overlay) return;
      overlay.classList.add('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (mForm) {
        var inp = mForm.querySelector('.header-search-input');
        if (inp) setTimeout(function () { inp.focus(); }, 50);
      }
    }
    function closeOverlay() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      if (mSugg) mSugg.classList.remove('is-open');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    if (toggle) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (overlay && overlay.classList.contains('is-open')) {
          closeOverlay();
        } else {
          openOverlay();
        }
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        closeOverlay();
      });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) {
        closeOverlay();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

document.querySelectorAll('.mobile-item.has-children > .acnav-label').forEach(label => {
  label.addEventListener('click', function(e) {
    // 1. Prevent the link from following the URL
    e.preventDefault();
    // 2. Stop other theme scripts from seeing this click
    e.stopPropagation();
    e.stopImmediatePropagation();

    const parent = this.parentElement;
    const submenu = parent.querySelector('.mobile_menu_inner');
    
    // Toggle active state for the arrow rotation
    parent.classList.toggle('is-open');
    
    // Toggle the visibility of the submenu
    if (submenu) {
      if (submenu.style.display === "none" || submenu.style.display === "") {
        submenu.style.display = "block";
        // Optional: ensure other open menus close (accordion style)
        this.setAttribute('aria-expanded', 'true');
      } else {
        submenu.style.display = "none";
        this.setAttribute('aria-expanded', 'false');
      }
    }
  }, true); // The 'true' here uses the capturing phase to catch the click first
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
